var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 2.66659C3.15668 2.66659 2.98712 2.73682 2.86209 2.86185C2.73707 2.98687 2.66683 3.15644 2.66683 3.33325V12.6666C2.66683 12.8434 2.73707 13.013 2.86209 13.138C2.98712 13.263 3.15669 13.3333 3.3335 13.3333H6.00016C6.36835 13.3333 6.66683 13.6317 6.66683 13.9999C6.66683 14.3681 6.36835 14.6666 6.00016 14.6666H3.3335C2.80306 14.6666 2.29435 14.4559 1.91928 14.0808C1.54421 13.7057 1.3335 13.197 1.3335 12.6666V3.33325C1.3335 2.80282 1.54421 2.29411 1.91928 1.91904C2.29436 1.54397 2.80306 1.33325 3.3335 1.33325H6.00016C6.36835 1.33325 6.66683 1.63173 6.66683 1.99992C6.66683 2.36811 6.36835 2.66659 6.00016 2.66659H3.3335Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1953 4.19526C10.4556 3.93491 10.8777 3.93491 11.1381 4.19526L14.4714 7.5286C14.7318 7.78894 14.7318 8.21106 14.4714 8.4714L11.1381 11.8047C10.8777 12.0651 10.4556 12.0651 10.1953 11.8047C9.93491 11.5444 9.93491 11.1223 10.1953 10.8619L13.0572 8L10.1953 5.13807C9.93491 4.87772 9.93491 4.45561 10.1953 4.19526Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3335 7.99992C5.3335 7.63173 5.63197 7.33325 6.00016 7.33325H14.0002C14.3684 7.33325 14.6668 7.63173 14.6668 7.99992C14.6668 8.36811 14.3684 8.66659 14.0002 8.66659H6.00016C5.63197 8.66659 5.3335 8.36811 5.3335 7.99992Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.cb3f8e1efe492bce2ba1101aecdae54f.svg";
export { ForwardRef as ReactComponent };